import { Text } from '@farmersdog/corgi-x';
import { NewsletterForm } from './NewsletterForm';

import styles from './NewsletterSection.module.css';

export const NewsletterSection = () => (
  <div className={styles.newsletterSection}>
    <Text as="h3" bold>
      Free Health and Nutrition Tips
    </Text>
    <NewsletterForm />
  </div>
);
